import { PaintedScene } from '../PaintedScene';

export const RIVERSIDE_WANDER_PHASER_KEY = 'RiversideWanderScene' as const;
export const RIVERSIDE_WANDER_MANIFEST_KEY = 's-110-riverside-wander' as const;

export class RiversideWanderScene extends PaintedScene {
  constructor() {
    super(RIVERSIDE_WANDER_PHASER_KEY, RIVERSIDE_WANDER_MANIFEST_KEY);
  }
}
